import React from 'react'

interface Props {
  name: string
  className: string
  w: number
  h?: number
  children: any
}

const IconBase = ({ name, className, w, h, children }: Props) => (
  <svg
    viewBox={`0 0 ${w} ${h ? h : w}`}
    xmlns="http://www.w3.org/2000/svg"
    className={`icon icon--${name}${className ? ' ' + className : ''}`}
  >
    {children}
  </svg>
)

export default IconBase
